import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
} from "shared-utility/store/utils/helpers";

// ACTIONS

export const COMPANY_SPONSOR_GET_COMPANIES = generateDefaultActions("COMPANY_SPONSOR_GET_COMPANIES");
export const getCompanies = payload => makePayload(COMPANY_SPONSOR_GET_COMPANIES.value, payload);
function* getCompaniesSaga(payload) {
  const url = "/companySponsor";
  yield requestSaga(COMPANY_SPONSOR_GET_COMPANIES, url, "GET");
}

export const COMPANY_SPONSOR_GET_COMPANY = generateDefaultActions("COMPANY_SPONSOR_GET_COMPANY");
export const getCompany = payload => makePayload(COMPANY_SPONSOR_GET_COMPANY.value, payload);
function* getCompanySaga(payload) {
  const { companyId } = payload;
  const url = `/companySponsor/${companyId}`;
  yield requestSaga(COMPANY_SPONSOR_GET_COMPANY, url, "GET");
}

export const COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS = generateDefaultActions("COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS");
export const modifyCompanySponsors = payload => makePayload(COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS.value, payload);
function* modifyCompanySponsorsSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const { companyId } = payload;
  const url = `/companySponsor/${companyId}`;
  yield requestSaga(COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS, url, "POST", payload);
  if (callback) {
    callback();
  }
}

// REDUCER

const initialState = {
  companies: [],
  company: {}
};

export function companySponsorReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case COMPANY_SPONSOR_GET_COMPANIES.success:
      return defaultReturn(state, payload, "companies");
    case COMPANY_SPONSOR_GET_COMPANY.success:
      return defaultReturn(state, payload.data, "company");
    case COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS.success:
      ToastSuccess("Sponsor Companies Updated");

      return defaultReturn(state, payload, "companies");

      // DEFAULT
    default:
      return state;
  }
}

// SAGA

export function* companySponsorSaga() {
  yield takeLatest(COMPANY_SPONSOR_GET_COMPANIES.value, getCompaniesSaga);
  yield takeLatest(COMPANY_SPONSOR_GET_COMPANY.value, getCompanySaga);
  yield takeLatest(COMPANY_SPONSOR_MODIFY_COMPANY_SPONSORS.value, modifyCompanySponsorsSaga);
}
